import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import * as Util from '../../Util';


class TravelogueBoard extends Component {
    constructor(props) {
        super(props);

        this.clickHandler = this.clickHandler.bind(this);
    }

    clickHandler() {
        if (this.props.data.url_id) {
            this.props.history.push('/info/'+this.props.data.url_id);
        } else if (this.props.data.file_content) {
            var anchor = document.createElement('a');
            anchor.href = this.props.data.file_content;
            anchor.target = "_blank"; //iOS - safari
            document.body.appendChild(anchor); //IE
            anchor.click();
            anchor.remove(); //IE
        }
    }

    render() {
        if (this.props.data) {
            let tagSpan = [<div style={{marginTop: 3}} key={'tag_br'}></div>];
            this.props.data.travelogue_tags.split(' ', 5).map((value, i) => {
                tagSpan.push(<div style={{paddingTop: 6, paddingLeft: 12}} key={'tag'+i}><span style={styles.tag}>#{value}</span></div>);
            })
            return (
                <div style={styles.flexitem}>
                <div style={styles.board(true)} onClick={this.clickHandler}>
                    <div style={{background: 'url("'+this.props.data.travelogue_cover+'")', backgroundPosition: 'center center', backgroundSize: 'cover', height: '85%'}}>
                        <div style={{height: 12}}>
                        </div>
                        <div style={styles.title}>
                            {this.props.data.travelogue_title}
                        </div>
                        <div>
                            {tagSpan}
                        </div>
                    </div>
                    <div style={styles.footer}>
                        総フライト時間：{this.props.data.flight_time_fee+' 分'}／ 合計金額：{Util.commaDelimiter(this.props.data.total_cost)+' 円'}
                    </div>
                </div>
                </div>
            );
            
        } else {
            return (
                <div style={styles.flexitem}>
                <div style={styles.board(false)}>
                    <div style={styles.dummy}>
                        <div style={{color: 'rgb(255, 255, 255)', fontSize: 'large'}}>
                            Coming Soon...
                        </div>
                    </div>
                </div>
                </div>
            );
        }
    }
}

const styles = {
    flexitem: {
        minWidth: '375px',
        width: '30%'
    },
    board: (clickable) => {
        return {
            width: '95%',
            height: 280,
            border: 'solid',
            borderColor: 'rgb(170, 170, 170)',
            margin: '24px auto 0 auto',
            position: 'relative',
            cursor: (clickable?'pointer':'unset')    
        }
    },
    title: {
        color: 'rgb(255, 255, 255)',
        backgroundColor: 'rgba(170, 170, 170, 0.5)',
        display: 'inline-block',
        margin: '0 12px',
        padding: 12
    },
    tag: {
        color: 'rgb(65, 105, 225)',
        fontSize: '80%',
        padding: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderRadius: 6
    },
    footer: {
        color: '#515151',
        textAlign: 'right',
        fontSize: 13,
        paddingTop: 15,
        paddingRight: 15
    },
    dummy: {
        width: '100%', 
        height: '100%', 
        backgroundColor: 'rgb(170, 170, 170)',
        display: 'flex', 
        justifyContent: 'center',
        alignItems: 'center'
    }
}

export default withRouter(TravelogueBoard);


// WEBPACK FOOTER //
// ./src/components/Travelogue/TravelogueBoard.js